

<div class="tvHeader">
    <div class="logoName">
        flowtrics
    </div>
    <div class="facName">
        Green Cares
    </div>
    <div class="dateTime">
        Tuesday, Jan 12 <span class="time" >11:00 AM</span>
    </div>
</div>
<div class="listHolder">
    <table class="table" >
        <tr>
            <th>Pat Arrival</th>
            <th>Sch Start</th>
            <th>Rooms</th>
            <th>Case ID</th>
            <th>Surgeon</th>
           
            <th>Status</th>
            <th>Update</th>
        </tr>
        <tr>
            <td>6:00 AM</td>
            <td>7:00 AM</td>
            <td>F1-1</td>
            <td>FL-291576</td>
            <td>M. Mcalpin</td>
            <td>Scheduled</td>
            <td>8:08 AM</td>
        </tr>
        <tr>
            <td>6:00 AM</td>
            <td>7:00 AM</td>
            <td>F1-1</td>
            <td>FL-291580</td>
            <td>M. Mcalpin</td>
            <td>In Room</td>
            <td>8:08 AM</td>
        </tr>
        
    </table>
</div>